import MyRoutes from "./router/routes";

function App() {
  return <MyRoutes />;
}

export default App;
